module.exports = __webpack_public_path__ + "static/slide1-54c2a76a001053275f6baca97e550533.jpg";